module.exports = __webpack_public_path__ + "static/media/result_6h2023.43b8f4e5.jpg";